<!-- 首页-公众服务和纪检举报 -->
<template>
  <div class="public-service">
    <div class="title mb16 mt16">公&ensp;众&ensp;服&ensp;务</div>
    <div class="version-center public-serviceflex">
      <div class="cards-box1">
        <div
          class="card1 flex-center hover-inter-active"
          @click="
            onMenuLinkItem(
              'http://116.252.25.141:8901/workspaces',
            )
          "
        >
          <img src="../../assets/images/font_1.webp" alt="" />
        </div>
        <div
          class="card1 card2 flex-center hover-inter-active"
          @click="
            onMenuLinkItem(
              'http://222.216.37.168:8086/mylims/resource/sunway/dxyqgx.jsp?url=/mylims/',
            )
          "
        >
          <img src="../../assets/images/font_2.webp" alt="" />
        </div>
      </div>

      <div class="flex icon-list">
        <!--客户须知-->
        <div
          @click="onMenuItem(listarr[0])"
          class="flex-center hover-inter-active"
          v-if="listarr[0]"
        >
          <img src="@/assets/images/home_icon_3.webp" alt="" />
          <span class="service-tag"> {{ listarr[0].tag }}</span>
        </div>
        <!--下载中心-->
        <div
          @click="onMenuItem(listarr[1])"
          class="flex-center hover-inter-active"
          v-if="listarr[1]"
        >
          <img src="@/assets/images/home_icon_1.webp" alt="" />
          <span class="service-tag"> {{ listarr[1].tag }}</span>
        </div>
        <!--常见问题-->
        <div
          @click="onMenuItem(listarr[2])"
          class="flex-center hover-inter-active"
          v-if="listarr[2]"
        >
          <img src="@/assets/images/home_icon_2.webp" alt="" />
          <span class="service-tag">{{ listarr[2].tag }}</span>
        </div>
        <!--业务咨询-->
        <div
          @click="onMenuItem(listarr[3])"
          class="flex-center hover-inter-active"
          v-if="listarr[3]"
        >
          <img src="@/assets/images/home_icon_3.webp" alt="" />
          <span class="service-tag">{{ listarr[3].tag }}</span>
        </div>
        <!--客户咨询会-->
        <div
          @click="onMenuItem(listarr[5])"
          class="flex-center hover-inter-active"
          v-if="listarr[5]"
        >
          <img src="@/assets/images/home_icon_6.webp" alt="" />
          <span class="service-tag">{{ listarr[5].tag }}</span>
        </div>
        <!--意见建议-->
        <div
          @click="onMenuItem(listarr[4])"
          class="flex-center hover-inter-active"
          v-if="listarr[4]"
        >
          <img src="@/assets/images/home_icon_4.webp" alt="" />
          <span class="service-tag">{{ listarr[4].tag }}</span>
        </div>
      </div>
      <div class="cards flex">
        <div
          @click="
            onMenuLinkItem(
              'https://datasearch.nmpa.gov.cn/datasearch/home-index.html#category=ylqx',
            )
          "
          class="cards1 flex-center hover-inter-active"
        >
          <img src="../../assets/images/font_3.webp" alt="" />
        </div>
        <div
          @click="
            onMenuLinkItem(
              'https://www.nidc.org.cn/xxgk/sjcx/index.html',
            )
          "
          class="cards2 flex-center hover-inter-active padding34"
        >
          <img src="../../assets/images/font_4.webp" alt="" />
        </div>
      </div>
      <div class="call-box">
        <div class="mb16 h60"><span>中心公开咨询电话：0771-2800500</span></div>
        <div class="mb16 h160">
          <span>中心检验工作投诉举报电话：0771-2898045</span>
          <span>投诉举报信箱：gxyxzxl@qq.com</span>
          <span>12315 投诉举报中心链接：</span>
          <br />
          <a href="https://tsgs.12315.cn/#/viewport" target="_blank"
            >https://tsgs.12315.cn</a
          >
        </div>
        <div class="h60">
          <img src="../../assets/images/home_icon_5.webp" alt="" />
          <a href="/report?title=首页">自治区纪委监委驻市场监管局纪检监察组</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "",
  components: {},
  props: [],
  data() {
    return {
      listarr: [],
    };
  },
  watch: {
    menuArr: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          const serviceItem = newVal.find((item) => item.title === "公众服务");
          this.listarr = serviceItem?.grouping2 || [];
          this.listarr = this.listarr.filter(item => item.tag !== '下载中心')
        } else {
          this.listarr = [];
        }
      },
    },
  },
  computed: {
    ...mapState(["menuArr"]),
  },
  mounted() {},
  created() {},
  methods: {
    // 跳转本地
    onMenuItem(query) {
      if (query.tag == "承检能力") {
        this.$router.push({
          path: "/institutional-overview",
          query: { title: "机构概况", tag: "承检能力", hash: "tab5" },
        });

        this.$store.commit("SET_TABS", {
          children: this.listarr,
        });
      } else {
        this.$router.push({
          path: "/document",
          query: { title: "公众服务", ...query },
        });

        this.$store.commit("SET_TABS", {
          children: this.listarr,
        });
      }
    },
    // 跳转第三方链接
    onMenuLinkItem(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scope>
.public-service {
  // padding-bottom: 40px;
  .public-serviceflex {
    display: flex;
    flex-wrap: wrap;
    .card-box {
      margin-top: 10px;
    }
    .cards-box1 {
      margin-right: 16px;
      width: 300px;
      .card1 {
        width: 100%;
        height: 146px;
        background: url(../../assets/images/customer_service_platform.webp)
          no-repeat;
        background-size: cover;
        border-radius: 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 22px;
        color: #ffffff;
        line-height: 24px;
        letter-spacing: 1px;
        text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
        text-stroke: 2px rgba(4, 85, 213, 0.54);
        text-align: center;
        font-style: normal;
        text-transform: none;
        -webkit-text-stroke: 2px rgba(4, 85, 213, 0.54);
      }
      .card2 {
        background: url(../../assets/images/home_bag_1.webp) no-repeat;
        background-size: cover;
        margin-top: 16px;
      }
    }

    .icon-list {
      width: 367px;
      height: 100%;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-right: 12px;
      div {
        border-radius: 4px;
        width: 178px;
        height: 93px;
        background-color: #ddebff;
        font-size: 18px;
        color: #333333;
        img {
          width: 52px;
          height: 52px;
          margin-bottom: 6px;
        }
      }
      :nth-child(1).flex-center,
      :nth-child(2).flex-center,
      :nth-child(3).flex-center,
      :nth-child(4).flex-center {
        margin-bottom: 17px;
      }
    }
    .cards {
      margin-right: 13px;
      width: 167px;
      flex-direction: column;
      justify-content: space-between;
      .cards1 {
        background: url(../../assets/images/home_bag_2.webp) no-repeat;
        background-size: 100% 100%;
      }
      .cards2 {
        background: url(../../assets/images/home_bag_3.webp) no-repeat;
        background-size: 100% 100%;
      }
      div {
        font-weight: bold;
        display: flex;
        align-items: center;
        height: 148px;
        width: 167px;
        border-radius: 4px;
        font-size: 22px;
        color: #fff;
        line-height: 29px;
        text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
        text-stroke: 1px rgba(4, 85, 213, 0.54);
        text-align: center;
        font-style: normal;
        text-transform: none;
        -webkit-text-stroke: 1px rgba(4, 85, 213, 0.54);
      }

      // :nth-child(1) {
      //   background: url(../../assets/images/home_bag_2.webp) no-repeat;
      //   background-size: 100% 100%;
      // }
      // :nth-child(2) {
      //   background: url(../../assets/images/home_bag_3.webp) no-repeat;
      //   background-size: 100% 100%;
      // }
      .padding16 {
        padding: 0 16px 0 16px;
      }
      .padding34 {
        padding: 0 34px 0 33px;
      }
    }
    .call-box {
      width: 325px;
      text-align: center;
      div {
        background: #e3edfb;
        border-radius: 4px;
        text-align: center;
        padding: 16px 0;
        img {
          width: 24px;
          margin-right: 4px;
        }
        u {
          color: #1b6ad2;
        }
        span,
        a {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 14px;
          color: #1b6ad2;
          line-height: 28px;
          display: inline-block;
        }
        a {
          text-decoration: underline;
        }
      }
      .h60 {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .h160 {
        height: 160px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .public-service {
    flex-direction: column;
    .public-serviceflex {
      padding: 0 !important;

      .cards-box1 {
        width: 100%;
        margin-right: 0;
        .card1 {
          width: 100%;
          border-radius: 10px;
          background-size: cover;
        }
      }
      .icon-list {
        margin-top: 16px;
        width: 100%;
        margin-right: 0;
        div {
          width: calc((100% - 16px) / 2);
        }
      }
      .cards {
        width: 100%;
        margin-bottom: 16px;
        margin-right: 0;
        div {
          width: 100%;
          margin-top: 16px;
        }
      }
      .call-box {
        width: 100%;
        margin-bottom: 16px;
        .h60 {
          display: flex;
          align-items: center;
          justify-content: center;
          height: max-content;
          padding: 4px;
          img {
            width: 20px;
            height: 20px;
          }
        }
        div {
          span,
          a {
            font-size: 16px;
          }
        }

        .h160 {
          height: max-content;
        }
      }
    }
  }
}
.service-tag {
  font-family: "Microsoft YaHei", "SimSun", "Arial Narrow" !important;
  color: #3b3b3b;
}
</style>
